module.exports = __webpack_public_path__ + "img/ward_dispenser.9836edee.png";